<a class="a00050" *ngIf='link' [href]="link" [target]="target">
    <span *ngIf="iconPath != 'none'" class="icon" [inlineSVG]="iconPath"></span>
    <span class="text">{{ text }}</span>
</a>
<a class="a00050" *ngIf='!link' (click)="linkClicked()">
    <span *ngIf="iconPath != 'none'"  class="icon" [inlineSVG]="iconPath"></span>
    <span class="text">{{ text }}</span>
</a>
